{
  "backup": {
    "config": {}
  },
  "bat": {
    "macros.doskey": {}
  },
  "Boot": {},
  "data": {
    "diagnostic_data": {}
  },
  "Drivers": {
    "network": {
      "rt640x64.cat": {},
      "rt640x64.inf": {},
      "rt640x64.sys": {}
    },
    "storage": {
      "RsCRIcon.dll": {},
      "RtsUer.inf": {},
      "RtsUer.sys": {},
      "rtsuer64.cat": {}
    }
  },
  "FirstDesk": {
    "System": {
      "Powershell": {}
    }
  },
  "ProgramFiles": {
    "AMD": {},
    "APM-Server": {},
    "Common_Files": {},
    "Dell": {},
    "DIFX": {},
    "dotnet": {},
    "ffmpeg": {},
    "Git": {},
    "Goodix": {},
    "IIS": {},
    "Intel": {},
    "Java": {},
    "mcafee": {},
    "MongoDB": {},
    "MSBuild": {},
    "MySQL": {},
    "nodejs": {},
    "OpenSSL-Win64": {},
    "PostgreSQL": {},
    "PuTTY": {},
    "Realtek": {},
    "Unity": {},
    "UNP": {},
    "Waves": {},
    "Security": {},
    "Mail": {},
    "MediaPlayer": {},
    "OSRuntime": {},
    "PhotoViewer": {},
    "PortableDevices": {},
    "SystemSecurity": {},
    "SystemSidebar": {},
    "SystemApps": {},
    "PowerShell": {},
    "WinRAR": {}
  },
  "ProgramData": {
    "Adobe": {},
    "AMD": {},
    "AnyDesk": {},
    "apm-server": {},
    "ApplicationData": {},
    "ATI": {},
    "AVASTSoftware": {},
    "Caphyon": {},
    "chocolatey": {},
    "Dell": {},
    "DellInc": {},
    "Desktop": {},
    "Disc-Soft": {},
    "Documents": {},
    "ElectronicArts": {},
    "GOG.com": {},
    "Goodix": {},
    "GraphicsType": {},
    "IDM": {},
    "Intel": {},
    "IObit": {},
    "McAfee": {},
    "FirstDesk": {},
    "CloudDrive": {},
    "VisualStudio": {},
    "Mozilla": {},
    "MySQL": {},
    "Oracle": {},
    "PackageCache": {},
    "Packages": {},
    "PCDr": {},
    "Posse": {}
  },
  "temp": {
    "AutofillRegex": {},
    "BrowserMetrics": {},
    "CertificateRevocation": {},
    "chrome_shutdown_ms.txt": {},
    "Crashpad": {},
    "CrashpadMetrics-active.pma": {},
    "CrowdDeny": {},
    "Default": {},
    "FileTypePolicies": {},
    "FirstRun": {},
    "Greaselion": {},
    "GrShaderCache": {},
    "hyphen-data": {},
    "LastBrowser": {},
    "LastVersion": {},
    "LocalState": {},
    "MEIPreload": {},
    "ModuleInfoCache": {},
    "SafeBrowsing": {},
    "SafetyTips": {},
    "ShaderCache": {},
    "SSLErrorAssistant": {}
  },
  "Users": {
    "Default": {},
    "Public": {},
    "Student": {
      "AppData": {},
      "config.cfg": {},
      "Contacts": {},
      "Cookies": {},
      "Desktop": {},
      "Documents": {},
      "Downloads": {},
      "Favorites": {},
      "geckodriver.log": {},
      "get-pip.py": {},
      "IntelGraphicsProfiles": {},
      "javac": {},
      "joke.txt": {
        "content": "I have a joke on recursion but I have a joke on ..."
      },
      "Links": {},
      "LocalSettings": {},
      "BrowserBackups": {},
      "Music": {},
      "MyDocuments": {},
      "NetHood": {},
      "CloudDrive": {},
      "Postman": {},
      "PrintHood": {},
      "Recent": {},
      "SavedGames": {},
      "Searches": {},
      "StartMenu": {},
      "supersecret.txt": {
        "content": "project: FirstDesk simulator lab\nwebsite: firstdesk.nl"
      },
      "Templates": {},
      "VirtualBoxVMs": {},
      "vmlogs": {}
    }
  },
  "System": {
    "addins": {},
    "appcompat": {},
    "apppatch": {},
    "AppReadiness": {},
    "assembly": {},
    "bcastdvr": {},
    "Boot": {},
    "Branding": {},
    "CbsTemp": {},
    "Containers": {},
    "Cursors": {},
    "debug": {},
    "diagnostics": {},
    "DiagTrack": {},
    "DigitalLocker": {},
    "ELAMBKUP": {},
    "Firmware": {},
    "Fonts": {},
    "GameBarPresenceWriter": {},
    "Globalization": {},
    "Help": {},
    "IAStorAfsService": {},
    "IdentityCRL": {},
    "IME": {},
    "ImmersiveControlPanel": {},
    "INF": {},
    "InfusedApps": {},
    "InputMethod": {},
    "Installer": {},
    "L2Schemas": {},
    "LanguageOverlayCache": {},
    "LiveKernelReports": {},
    "Logs": {},
    "Media": {},
    "Migration": {},
    "ModemLogs": {},
    "OCR": {},
    "Panther": {},
    "Performance": {},
    "PLA": {},
    "PolicyDefinitions": {},
    "Prefetch": {},
    "PrintDialog": {},
    "Provisioning": {},
    "Registration": {},
    "rescache": {},
    "Resources": {},
    "SchCache": {},
    "schemas": {},
    "scratch": {},
    "security": {},
    "ServiceProfiles": {},
    "ServiceState": {},
    "servicing": {},
    "Setup": {},
    "ShellComponents": {},
    "ShellExperiences": {},
    "SKB": {},
    "SoftwareDistribution": {},
    "Speech": {},
    "Speech_OneCore": {},
    "System": {},
    "System32": {},
    "SystemApps": {},
    "SystemResources": {},
    "SysWOW64": {},
    "TAPI": {},
    "Tasks": {},
    "Temp": {},
    "TextInput": {},
    "tracing": {},
    "Web": {}
  }
}
